/// Port of mobile/lib/user/data/api_user_repository.dart.
/// Live profile / score / leaderboard calls against /v1/users/*.

import { ApiError, apiClient } from '@/app/network/apiClient';
import type { Ranking, User } from '../domain/user';
import { rankingFromJson, userFromJson } from '../domain/user';

export async function getProfile(userId: string): Promise<User> {
  const body = await apiClient.get<Record<string, unknown>>(`/v1/users/${userId}`);
  return userFromJson(body);
}

export async function updateUsername(username: string): Promise<User> {
  const body = await apiClient.patch<Record<string, unknown>>('/v1/users/me/username', {
    username,
  });
  return userFromJson(body);
}

export async function updateHighScore(highScore: number): Promise<User> {
  const body = await apiClient.put<Record<string, unknown>>('/v1/users/me/score', {
    high_score: highScore,
  });
  return userFromJson(body);
}

export async function getLeaderboard(limit = 10, offset = 0): Promise<Ranking[]> {
  const body = await apiClient.get<Record<string, unknown>[] | null>(
    `/v1/users/leaderboard?limit=${limit}&offset=${offset}`,
    { anonymous: true },
  );
  return (body ?? []).map(rankingFromJson);
}

export async function getMyRank(): Promise<Ranking | null> {
  try {
    const body = await apiClient.get<Record<string, unknown>>('/v1/users/me/rank');
    return rankingFromJson(body);
  } catch (error) {
    if (error instanceof ApiError && (error.status === 401 || error.status === 404)) {
      return null;
    }
    throw error;
  }
}

export async function deleteAccount(username: string): Promise<void> {
  await apiClient.delete<void>('/v1/users/me', { username });
}
